<template>
  <span>
    <svg
      v-if="isPlus"
      xmlns="http://www.w3.org/2000/svg"
      width="34.875"
      height="34.875"
      viewBox="0 0 34.875 34.875"
    >
      <path
        id="Icon_awesome-plus-circle"
        data-name="Icon awesome-plus-circle"
        d="M18,.563A17.438,17.438,0,1,0,35.438,18,17.434,17.434,0,0,0,18,.563ZM28.125,19.969a.846.846,0,0,1-.844.844H20.813v6.469a.846.846,0,0,1-.844.844H16.031a.846.846,0,0,1-.844-.844V20.813H8.719a.846.846,0,0,1-.844-.844V16.031a.846.846,0,0,1,.844-.844h6.469V8.719a.846.846,0,0,1,.844-.844h3.938a.846.846,0,0,1,.844.844v6.469h6.469a.846.846,0,0,1,.844.844Z"
        transform="translate(-0.563 -0.563)"
        fill="#b8c7ce"
      />
    </svg>

    <svg
      v-else
      xmlns="http://www.w3.org/2000/svg"
      width="20.788"
      height="20.788"
      viewBox="0 0 20.788 20.788"
    >
      <path
        id="Icon_awesome-minus-circle"
        data-name="Icon awesome-minus-circle"
        d="M10.957.563A10.394,10.394,0,1,0,21.351,10.957,10.392,10.392,0,0,0,10.957.563ZM16.992,12.13a.5.5,0,0,1-.5.5H5.424a.5.5,0,0,1-.5-.5V9.783a.5.5,0,0,1,.5-.5H16.489a.5.5,0,0,1,.5.5Z"
        transform="translate(-0.563 -0.563)"
        fill="#b8c7ce"
      />
    </svg>
  </span>
</template>
<script>
export default {
  props: {
    isPlus: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
}
</script>
